module.exports = __webpack_public_path__ + "img/LL.0ce61bba.png";